<template>
  <nav class="header">
    <div>
      <ul class="flex nav nav-pills">
        <li :class="['nav-item app-logo', { 'selected-nav-item': fit20.selectTabId == 'tab_id0' }]">
          <a href="#studios" id="studios-tab" @click.stop.prevent="selectTab('#studios', 'tab_id0')"
            :class="{ 'active': fit20.selectTabId == 'tab_id0' }">
            <img :src="fit20.storageBaseUrl + '/static/images/fit20-logo.png'" />

          </a>

        </li>
        <span class="server-name" v-if="isBeta"><b>Beta</b></span>
        <span class="server-name" v-if="isTest"><b>Test</b></span>
        <span class="server-name" v-if="isLocal"><b>local</b></span>
        <li :class="['nav-item tabs', { 'selected-nav-item': fit20.selectTabId == 'tab_id1' }]">
          <a v-if="fit20.studio.id" @click.stop.prevent="selectTab('#members', 'tab_id1')" id="members-tab"
            :class="{ 'active': fit20.selectTabId == 'tab_id1' }" href=" #members" :title="'currentStudio.id'">
            <div>
              {{ capitalizeFirstLetter(fit20.studio.displayName) }}
            </div>
          </a>
        </li>
        <template v-for="tab, index in fit20.currentMembers">
          <!-- tabs 2 3 4 -->
          <li :id="'tab_id' + (index + 2)"
            :class="['nav-item tabs', { 'selected-nav-item': fit20.selectTabId == 'tab_id' + (index + 2) }]"
            v-if="tab[0]">
            <a :class="{ 'active': fit20.selectTabId == 'tab_id' + (index + 2) }"
              @click.stop.prevent="selectTab('#member-', 'tab_id' + (index + 2))" :href="'#member-'">
              <div class="flex justify-content">
                <div>
                  <div>{{ tab[0].displayFirstName }}</div>
                  <div v-if="partnersNames(tab[0])[0]">{{
                    capitalizeFirstLetter(partnersNames(tab[0])[0]) }}
                  </div>
                  <div v-if="partnersNames(tab[0])[1]">{{
                    capitalizeFirstLetter(partnersNames(tab[0])[1]) }}
                  </div>
                  <div v-if="partnersNames(tab[0])[2]">{{
                    capitalizeFirstLetter(partnersNames(tab[0])[2]) }}
                  </div>
                </div>
                <div @click="handleSessionAction('tab' + (index + 2), 'new session')" class="dynamic-btn"
                  v-if="fit20.selectTabId == 'tab_id' + (index + 2) && !fit20.tabs['tab' + (index + 2)].active"><img
                    class="new-session-btn" width="50px" :src="fit20.storageBaseUrl + '/static/icons/%2B.png'">
                </div>
                <div @click="handleSessionAction('tab' + (index + 2), 'save')" class="dynamic-btn"
                  v-if="fit20.selectTabId == 'tab_id' + (index + 2) && fit20.tabs['tab' + (index + 2)].active && fit20.saveSessionControl['tab' + (index + 2)].length < 1">
                  <img class="new-session-btn" width="45px" :src="fit20.storageBaseUrl + '/static/icons/save.png'">
                </div>
                <div @click="handleSessionAction('tab' + (index + 2), 'cancel')" class="dynamic-btn"
                  v-if="fit20.selectTabId == 'tab_id' + (index + 2) && fit20.tabs['tab' + (index + 2)].active && fit20.saveSessionControl['tab' + (index + 2)].length < 1">
                  <img class="new-session-btn" width="45px" :src="fit20.storageBaseUrl + '/static/icons/x.png'">
                </div>
                <div class="close-btn"
                  v-if="fit20.selectTabId == 'tab_id' + (index + 2) && !fit20.tabs['tab' + (index + 2)].active">
                  <img width="20px" @click="closeTap(index)" :src="fit20.storageBaseUrl + '/static/icons/x-btn.png'">
                </div>
              </div>
            </a>
          </li>
        </template>
        <li class="nav-item burger" @click="openMenu()" v-if="fit20.user && fit20.user.email">
          <div class="burger-div" id="">
            <img :src="fit20.storageBaseUrl + '/static/images/hamburger-menu.svg'" />
          </div>
        </li>
      </ul>
    </div>
    <!-- start the side menu -->
    <div v-if="showMenu" class="side-menu">
      <div class="menu-header flex">
        <div @click="editUserPopup()"><img width="40" :src="getUserPhoto()" /></div>
        <div class="trainer-name" @click="editUserPopup()">
          <div>{{ fit20.user.displayFirstName }}</div>
          <div>{{ fit20.user.displayLastName }}</div>
        </div>
        <div class="close" @click="openMenu()"><img width="25"
            :src="fit20.storageBaseUrl + '/static/icons/x-btn.png'" />
        </div>
      </div>
      <div class="menu-items">
        <div v-if="fit20.studio.id" @click="addMemberPopup">{{ $t('new-member') }}</div>
        <div v-if="fit20.studio.id && fit20.studio.sensor" @click="sensorPopup">{{ $t('sensors') }}</div>
        <div @click="malfunction()">{{ $t('malfunction') }}</div>
        <div @click="closeFAQ">{{ $t('FAQ') }}</div>
        <div v-if="fit20.studio.id" @click="getStudioReports()">{{ $t('studio-report') }}</div>
        <div @click="signOut">{{ $t('log-out') }}</div>
      </div>
      <div class="sensor-icon">
        <img v-if="fit20.studio.id && fit20.studio.sensor" width="40"
          :src="fit20.storageBaseUrl + '/machine-setting/sensor-green.svg'" />
        <img v-if="fit20.studio.id && !fit20.studio.sensor" width="40"
          :src="fit20.storageBaseUrl + '/machine-setting/sensor-red.svg'" />
      </div>
    </div>
    <!-- end the side menu -->

    <Sensors v-if="showSensorsPopup && fit20.sensorsMachines.length > 0" :fit20="fit20" :sensorPopup="sensorPopup">
    </Sensors>
    <!-- start add member popup  -->
    <div class="popup-overlay" v-if="showAddMemberPopup">
      <div class="edit-member animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ $t('new-member') }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="addMemberPopup()" />
        </div>
        <div class="add-member-studio">{{ capitalizeFirstLetter($t('studio')) }} : {{ fit20.studio.displayName }}</div>
        <div class="flex add-member-body">
          <form class="session-form-container" id="admin_studio_info">
            <div class="flex edit-member-1sec">
              <div class="field-sec">
                <input :placeholder="$t('first-name')" type="text" class="form-control"
                  v-model="newMember.displayFirstName" />
              </div>
              <div class="field-sec">
                <input :placeholder="$t('last-name')" type="text" class="form-control"
                  v-model="newMember.displayLastName" />
              </div>
              <div class="field-sec date">
                <input type="text" :placeholder="newMember.birthDate ? '' : $t('date-of-birth')" class="form-control"
                  readonly />
                <Datepicker ref="datepicker" v-model="newMember.birthDate" class="form-control date-picker">
                </Datepicker>
              </div>
              <div class=" field-sec">
                <select v-model="newMember.gender">
                  <option value="">{{ capitalizeFirstLetter($t('gender')) }}</option>
                  <option value="male">{{ capitalizeFirstLetter($t('male')) }}</option>
                  <option value="female">{{ capitalizeFirstLetter($t('female')) }}</option>
                  <option value="other">{{ capitalizeFirstLetter($t('other')) }}</option>
                </select>
              </div>
              <div class="field-sec">
                <input :placeholder="$t('email')" type="email" class="form-control" v-model="newMember.email" />
              </div>
              <div class="field-sec">
                <input :placeholder="$t('phone')" type="text" class="form-control" v-model="newMember.phone">
              </div>
              <div class="field-sec">
                <select v-model="newMember.language">
                  <option value="">{{ $t('language') }}</option>
                  <option v-for="language in fit20.languages" :value="language.code" :key="language.code">{{
                    language.name
                  }}
                  </option>
                </select>
              </div>
              <div class="field-sec">
                <select class="" v-model="newMember.status">
                  <option value="">{{ capitalizeFirstLetter($t('status')) }}</option>
                  <option value="prospect">{{ capitalizeFirstLetter($t('prospect')) }}</option>
                  <option value="member">{{ capitalizeFirstLetter($t('member')) }}</option>
                </select>
              </div>
            </div>
            <div class="field-sec flex">
              <label class="">{{ $t('start-membership') }}</label>
              <input type="date" class="form-control" v-model="newMember.startMembership" />
            </div>
            <div class="field-sec flex">
              <label class="">{{ $t('end-membership') }}</label>
              <input type="date" class="form-control" v-model="newMember.endMembership" />
            </div>
            <div class="field-sec flex">
              <label>{{ $t('height-in-cm') }}</label>
              <input type="number" class="form-control height" v-model="newMember.height">
            </div>
            <div class="field-sec flex">
              <label>{{ $t('weight-in-kg') }}</label>
              <input type="number" class="form-control height" v-model="newMember.measure[0].weight">
            </div>
            <div>
              <div class="fake-div"></div>
              <div class="btn-container">
                <img class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
                  @click="saveMember">
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- end add member popup-->
    <!-- start edit user popup  -->
    <div class="popup-overlay" v-if="showEditUserPopup">
      <div class="edit-member animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ fit20.user.displayFirstName }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="editUserPopup()" />
        </div>
        <div class="flex edit-user-sec">
          <div class="user-img-div" width="100" @click="showUserPhotoPopup()">
            <img class="member-img" v-if="fit20.user.photo && fit20.user.photo != 0" width="100"
              :src="fit20.storageBaseUrl + '/user/' + fit20.user.id + '.png?generation=' + fit20.user.photo" />
            <img v-if="!fit20.user.photo || fit20.user.photo == 0" width="100"
              :src="fit20.storageBaseUrl + '/user/default.svg'" />
            <img class="user-img-ico" width="35" :src="fit20.storageBaseUrl + '/static/icons/+foto.svg'" />
          </div>
          <div class="flex edit-user-body">
            <form class="session-form-container" id="admin_studio_info">
              <div class="flex edit-member-1sec">
                <div class="field-sec">
                  <input :placeholder="$t('first-name')" type="text" class="form-control"
                    v-model="fit20.user.displayFirstName" />
                </div>
                <div class="field-sec">
                  <input :placeholder="$t('last-name')" type="text" class="form-control"
                    v-model="fit20.user.displayLastName" />
                </div>
                <div class="field-sec date">
                  <input type="text" :placeholder="fit20.user.birthDate ? '' : $t('date-of-birth')" class="form-control"
                    readonly />
                  <Datepicker ref="datepicker" v-model="fit20.user.birthDate" class="form-control date-picker">
                  </Datepicker>
                </div>

                <div class="field-sec">
                  <select v-model="fit20.user.gender" :placeholder="capitalizeFirstLetter($t('gender'))">
                    <!-- <option value="">{{ $t('gender') }}</option> -->
                    <option value="male">{{ capitalizeFirstLetter($t('male')) }}</option>
                    <option value="female">{{ capitalizeFirstLetter($t('female')) }}</option>
                    <option value="other">{{ capitalizeFirstLetter($t('other')) }}</option>
                  </select>
                </div>
                <div class="field-sec">
                  <input :placeholder="$t('email')" type="email" class="form-control" v-model="fit20.user.email"
                    disabled />
                </div>
                <div class="field-sec">
                  <select v-model="fit20.user.language">
                    <option value="">{{ $t('language') }}</option>
                    <option v-for="language in fit20.languages" :value="language.code" :key="language.code">{{
                      language.name
                    }}
                    </option>
                  </select>
                </div>
              </div>
              <div>
                <div class="fake-div"></div>
                <!-- <div class="btn-container">
                  <span :class="'fit20-btn ' + 'save-btn-active'" @click="saveUser()">{{ $t('save') }}</span>
                </div> -->
                <div class="btn-container">
                  <img class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
                    @click="saveUser()">
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end add user popup-->

    <!-- start send err report popup  -->
    <div class="popup-overlay" v-if="showMalfunctionPopup">
      <div class="edit-member animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ $t('malfunction') }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="malfunction()" />
        </div>
        <div class="flex edit-user-sec">

          <div class="flex edit-user-body">
            <form class="session-form-container malfunction-text" id="admin_studio_info">
              <div class="description-container">
                <textarea :placeholder="$t('description-ph')" v-model="description" width="90%" height="400"></textarea>
                <div class="btn-container">
                  <img class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
                    @click="sendErrReport()">
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End send err report popup  -->

    <!-- start edit user photo popup  -->
    <div class="popup-overlay" v-if="showPhotoPopup">
      <Photo :title="fit20.user.displayFirstName" :id="fit20.user.id" :changePhoto="changePhoto" :savePhoto="savePhoto"
        :togglePopup="showUserPhotoPopup" :photo="userPhoto" :fit20="fit20" :togglePopupValues="[false, false, true]"
        :newPhoto="newPhoto" />
    </div>
    <div class="popup-overlay" v-if="showFAQPopup">
      <Helpdoc :fit20="fit20" :closeFAQ="closeFAQ" :closeIcon="fit20.storageBaseUrl + '/static/icons/white-x.svg'" />
    </div>
    <!-- start edit user photo popup  -->
  </nav>
</template>

<script>
import Sensors from "./Sensors.vue";
import Photo from "./Photo.vue";
import Helpdoc from "./Helpdoc.vue";
import { getErrorReportStr, getStudioReportStr, formattedDateTime, isValidEmail } from "../actions/global"
import Datepicker from 'vuejs-datepicker';
import html2canvas from "html2canvas";

export default {
  name: 'Header',
  components: {
    Sensors,
    Photo,
    Helpdoc,
    Datepicker,
  },
  props: ["fit20", "selectTab", "clearLocalStorage"],
  data() {
    return {
      isBeta: window.location.host.includes('beta'),
      isTest: window.location.host.includes('test.'),
      isLocal: window.location.host.includes('local'),
      canvas: '',
      description: '',
      showMalfunctionPopup: false,
      showFAQPopup: false,
      showPhotoPopup: false,
      userPhoto: false,
      newPhoto: false,
      showEditUserPopup: false,
      maxDate: new Date().toISOString(),
      showMenu: false,
      showSensorsPopup: false,
      showAddMemberPopup: false,
      birthDate: '',
      gender: '',
      newMember: {
        displayFirstName: "",
        displayLastName: "",
        firstName: "",
        lastName: "",
        studios: [{
          id: this.fit20.studio.id,
          memberStatus: '', // add it before save
          partners: [],
          main: true,
        }],
        email: '',
        phone: '',
        startMembership: '',
        endMembership: '',
        status: '',
        gender: '',
        measure: [{
          date: new Date().toISOString(),
          weight: 0
        }],
        height: 0,
        language: '',
      },
    };
  },
  methods: {
    malfunction: function () {
      this.showMenu = false;
      this.canvas = '';
      this.showMalfunctionPopup = !this.showMalfunctionPopup;
      this.description = "";
    },
    sendErrReport: async function () {

      let imageName = this.fit20.user.id + Date.now() + '.png';


      let errReportHtml = getErrorReportStr(this.fit20, this.description, imageName);

      // fire zoho webhook....
      let zohoWebBaseURL = 'https://flow.zoho.eu/20065826555/flow/webhook/incoming?zapikey=1001.84110bc1e18ce98095b9de7401bd3e44.ccbfb31ea86947d5d92f2b01623a34c2&isdebug=false';
      // const zohoWebHookURL = zohoWebBaseURL;
      var data = new FormData();
      data.append('text', errReportHtml);
      let studioName = this.fit20.studio && this.fit20.studio.name ? this.fit20.studio.name : this.fit20.user.displayFirstName;
      data.append('studio', studioName);

      fetch(
        zohoWebBaseURL,
        {
          mode: 'no-cors',
          method: 'POST',
          body: data,
        },
      );

      this.showMalfunctionPopup = false;
      this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('confirm-malfunction') });

      const element = document.getElementById("app");
      // this.fit20.isLoaded = false;
      this.canvas = await html2canvas(element, {
        width: window.innerWidth,  // Set canvas width to viewport width
        height: window.innerHeight,
        useCORS: true,
        allowTaint: false,
      });
      const imgData = this.canvas.toDataURL("image/png");
      const formData = new FormData();
      formData.append("image", imgData);
      // this.fit20.isLoaded = true;

      fetch(
        this.fit20.baseUrl + "/api/photos/errors/" + imageName + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email,
        {
          method: 'POST',
          body: formData,
        }
      );
    },
    signOut() {
      if (confirm(this.$t('log-out?'))) {
        const logoutWindow = window.open('https://mail.google.com/mail/?logout&hl=en', 'Disconnect from Google', 'width=100,height=50,menubar=no,status=no,location=no,toolbar=no,scrollbars=no,top=200,left=200');
        setTimeout(() => {
          if (logoutWindow && !logoutWindow.closed) {
            logoutWindow.close();
          }
        }, 1200);
        this.fit20.isLoaded = false;
        localStorage.removeItem('user-email');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('last_token_time');
        localStorage.removeItem('check_time');
        localStorage.setItem('sign_out_msg', this.$t('logout-msg'));
        localStorage.setItem('sign_in', this.$t('login'));
        setTimeout(() => {
          this.fit20.isLoaded = true;
          this.fit20.logout = true;
          window.location.href = window.location.origin + '/logout.html';
        }, 1500); // Redirect back after 2 seconds
      }
    },
    getStudioReports: async function () {

      if (this.fit20.studio.members && this.fit20.studio.members.length > 0) {
        try {
          if (window.confirm(this.$t('studio-report-confirm'))) {
            this.fit20.isLoaded = false;
            let dataToDisplay = [];
            let members = this.fit20.studio.members.filter(member => member.status != 'exMember' && member.status != 'exProspect').sort((a, b) => a.firstName.localeCompare(b.firstName));
            await Promise.all(members.map(async member => {
              try {
                let getMember = await fetch(this.fit20.baseUrl + "/api/members/one/" + member.id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
                let result = await getMember.json();
                let oneMember;
                if (result.msg) {
                  if (result.msg == "invalid-token") {
                    this.clearLocalStorage();
                  }
                  alert(this.$t(result.msg));
                } else {
                  oneMember = result;
                }
                let res = await fetch(this.fit20.baseUrl + '/api/sessions/' + member.id + '/Member?limit=5&accessToken=' + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
                let data;
                let memberSessions = await res.json();
                if (memberSessions.msg && memberSessions.msg == "invalid-token") {
                  this.clearLocalStorage();
                  alert(this.$t(memberSessions.msg));
                } else {
                  data = memberSessions;
                  if (data && data.msg) {
                    data = [];
                  }
                }

                dataToDisplay.push({ member: oneMember, sessions: data });
              } catch (err) {
                console.log(err);
                this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
                this.fit20.errors.push('Error with studio report:' + JSON.stringify({
                  message: err.message,
                  stack: err.stack,
                  name: err.name,
                }) + " " + formattedDateTime());
              }
            }))
            const htmlContent = await getStudioReportStr(dataToDisplay, this.fit20.studioMachines, this.fit20.studio.id, this.fit20.storageBaseUrl, this.fit20.studio.name);
            const blob = new Blob([htmlContent], { type: 'text/html' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = this.fit20.studio.name + '.html';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            this.fit20.isLoaded = true;
          }
        } catch (err) {
          console.log(err);
          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('studio-report-err') });
          this.fit20.errors.push('Error with studio report:' + err + " " + formattedDateTime());
        }
      } else {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('no-members') })
      }
    },
    closeFAQ: function () {
      this.showFAQPopup = !this.showFAQPopup;
    },
    changePhoto: function (e) {
      try {
        const file = e.target.files[0]; // Get the first selected file

        if (file) {
          // Use FileReader to read the selected file
          const reader = new FileReader();
          reader.onload = (e) => {
            this.userPhoto = e.target.result; // Set the imageUrl to the data URL
            this.newPhoto = e.target.result;
          };
          reader.readAsDataURL(file);
        }
      } catch (err) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('reading-photo-failed') });
        this.fit20.errors.push('Error with changePhoto in Header.vue:' + err + " " + formattedDateTime());
        console.error('Error with changePhoto');
      }
    },
    savePhoto: async function () {
      if (this.newPhoto) {
        const formData = new FormData();
        formData.append('image', this.newPhoto);
        const res = await fetch(this.fit20.baseUrl + "/api/photos/user/" + this.fit20.user.id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          body: formData,
        });
        if (res.ok) {
          let photo = await res.json();
          if (photo.msg) {
            if (photo.msg == "invalid-token") {
              this.clearLocalStorage();
            }
            alert(this.$t(photo.msg));
          } else {
            this.fit20.user.photo = photo;
          }
        } else {
          this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('general-err-msg') });
          this.fit20.errors.push('Error with savePhoto in Header.vue:' + " " + formattedDateTime());
          console.log('Error with save user Photo');
        }
      }
      this.newPhoto = false;
      this.showPhotoPopup = !this.showPhotoPopup;
    },
    showUserPhotoPopup: function () {
      this.showPhotoPopup = !this.showPhotoPopup;
      this.userPhoto = this.fit20.storageBaseUrl + "/user/" + (this.fit20.user.photo ? this.fit20.user.id + ".png?generation=" + this.fit20.user.photo : "default.svg");
      this.newPhoto = false;
    },
    openMenu: function () {
      this.showMenu = !this.showMenu;
    },
    sensorPopup: function () {
      this.showSensorsPopup = !this.showSensorsPopup;
      this.showMenu = false;
    },
    addMemberPopup: function () {
      this.showAddMemberPopup = !this.showAddMemberPopup;
      this.showMenu = false;
    },
    editUserPopup: function () {
      this.showEditUserPopup = !this.showEditUserPopup;
      this.showMenu = false;
    },
    getUserPhoto: function () {
      if (this.fit20.user.photo) {
        return this.fit20.storageBaseUrl + '/user/' + this.fit20.user.id + '.png?generation=' + this.fit20.user.photo;
      } else {
        return this.fit20.storageBaseUrl + '/user/default.svg';
      }
    },
    capitalizeFirstLetter(string) {
      if (string) {
        return string[0].toUpperCase() + string.slice(1);
      } else {
        return '';
      }
    },
    handleSessionAction: function (tab, action) {
      if (action == 'cancel') {
        this.fit20.alerts.push({
          id: Date.now(),
          type: 'confirmation', // Change type to 'confirmation'
          msg: this.$t('cancel-session-confirmation'),
          onConfirm: () => {
            // If user clicks "Continue"
            this.fit20.tabs[tab]['active'] = false;
            this.fit20.tabs[tab]['action'] = 'cancel';
            // let tempSessions = [];
            // localStorage.setItem(
            //   this.fit20.studio,
            //   JSON.stringify(tempSessions)
            // );

          },
        });
      } else {

        this.fit20.tabs[tab]['active'] = action == 'new session' ? true : false;
        this.fit20.tabs[tab]['action'] = action;
      }
    },

    cancelSession: function (tab) {
      this.fit20.alerts.push({
        id: Date.now(),
        type: 'confirmation', // Change type to 'confirmation'
        msg: this.$t('cancel-session-confirmation'),
        onConfirm: () => {
          // If user clicks "Continue"
          this.fit20.tabs[tab]['active'] = false;
          this.fit20.tabs[tab]['action'] = 'cancel';
        },
      });
    },
    saveSession: function (tab) {

      this.fit20.tabs[tab]['active'] = false;
      this.fit20.tabs[tab]['action'] = 'save';

    },
    partnersNames: function (member) {
      if (member) {
        const names = [];
        let currentStudio = member.studios.find(studio => studio.id == this.fit20.studio.id);
        if (currentStudio) {
          currentStudio.partners.forEach(partner => {
            let existPartner = this.fit20.studio.members.find(member => member.id == partner.id);
            if (existPartner && existPartner.firstName) {
              names.push(existPartner.firstName);
            }
          })
        }
        return names;
      } else {
        return "";
      }

    },

    saveMember: async function () {

      if (!this.newMember.displayFirstName) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('required-field').replace('{field}', this.$t('first-name')) });
      } else if (!this.newMember.displayLastName) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('required-field').replace('{field}', this.$t('last-name')) });
      } else if (this.newMember.email && this.newMember.email.length > 0 && !isValidEmail(this.newMember.email)) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('invalid-email') });
      } else if (this.newMember.measure[0].weight !== 0 && this.newMember.measure[0].weight.length < 2) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('invalid-weight') });
      } else if (this.newMember.height !== 0 && this.newMember.height.length < 2) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('height-validation') });
      } else {
        if (!this.newMember.status) {
          this.newMember.status = 'prospect';
        }
        try {
          this.fit20.isLoaded = false;
          this.newMember.firstName = this.newMember.displayFirstName;
          this.newMember.lastName = this.newMember.displayLastName;
          this.newMember.studios[0].memberStatus = this.newMember.status;
          this.newMember.studios[0].id = this.fit20.studio.id;
          let addMember = await fetch(this.fit20.baseUrl + "/api/members/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.newMember),
          });
          this.newMember = {
            displayFirstName: "",
            displayLastName: "",
            firstName: "",
            lastName: "",
            studios: [{
              id: this.fit20.studio.id,
              memberStatus: '', // add it before save
              partners: [],
              main: true,
            }],
            email: '',
            phone: '',
            startMembership: '',
            endMembership: '',
            status: '',
            gender: '',
            measure: [{
              date: new Date().toISOString(),
              weight: 0
            }],
            height: 0,
            language: '',
          };
          let result = await addMember.json();
          let newMember;
          if (result.msg) {
            if (result.msg == "invalid-token") {
              this.clearLocalStorage();
            }
            alert(this.$t(result.msg));
          } else {
            newMember = result;
          }
          this.fit20.studio.members.push({
            id: newMember.id,
            status: newMember.status,
            firstName: newMember.displayFirstName,
            lastName: newMember.displayLastName,
            main: true,
            photo: false,
            partners: [],
          });
          this.fit20.studio.memberCount = this.fit20.studio.memberCount + 1;
          this.showAddMemberPopup = false;

          this.fit20.isLoaded = true;
        } catch (err) {
          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
          this.fit20.errors.push('Error with saveMember in Header.vue:' + JSON.stringify({
            message: err.message,
            stack: err.stack,
            name: err.name,
          }) + " " + formattedDateTime());
          console.log('Error with saveMember Photo');
        }
      }
    },
    saveUser: async function () {
      if (!this.fit20.user.displayFirstName) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('required-field').replace('{field}', this.$t('first-name')) });
      } else if (!this.fit20.user.displayLastName) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'info', msg: this.$t('required-field').replace('{field}', this.$t('last-name')) });
      } else {
        try {
          this.fit20.user.firstName = this.fit20.user.displayFirstName.toLowerCase();
          this.fit20.user.lastName = this.fit20.user.displayLastName.toLowerCase();

          let updateUser = await fetch(this.fit20.baseUrl + "/api/users/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.fit20.user),
          });

          let result = await updateUser.json();
          if (result.msg) {
            if (result.msg == "invalid-token") {
              this.clearLocalStorage();
            }
            alert(this.$t(result.msg));
          } else {
            this.$i18n.setLocaleMessage(this.fit20.user.language, this.fit20.messages[this.fit20.user.language]);
            this.$i18n.locale = this.fit20.user.language;
          }
          this.showEditUserPopup = false;
        } catch (err) {
          this.showEditUserPopup = false;
          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
          this.fit20.errors.push('Error with saveUser in Header.vue:' + JSON.stringify({
            message: err.message,
            stack: err.stack,
            name: err.name,
          }) + " " + formattedDateTime());
          console.error('Error with saveUser Photo');
        }
      }
    },
    closeTap: function (tabNum) {
      this.fit20.currentMembers[tabNum] = [];
      this.selectTab('tab_id' + (tabNum + 1), 'tab_id1');
    }
  },
};
</script>

<style>
.server-name {
  position: absolute;
  left: 150px;
}

.header {
  height: 60px;
  border-bottom: solid 2px var(--fit20-lighter-gray);
  position: relative;
}

.nav-pills {
  margin-top: 10px;
}

.flex .justify-content {
  justify-content: space-around;
}

.app-logo {
  width: 25%;
}

.app-logo.selected-nav-item {
  width: 35% !important;
  background: white;
}

.app-logo img {
  height: 58px;
  margin-bottom: 15px;
  position: absolute;
  top: 0;
}

.nav-item {
  height: 62px;
  transition: all .4s;
}

.nav-item a {
  display: inline-block;
  height: 95%;
  width: 100%;
  color: var(--fit20-lighter-gray);
  border-left: solid 2px var(--fit20-lighter-gray);
}

.selected-nav-item {
  width: 25% !important;
  border-bottom: solid 2px transparent;
  background: white;
  transition: all .4s;
}

.selected-nav-item a.active {
  color: var(--fit20-gray);
  border-left: solid 2px var(--fit20-green);
  background: white;
  transition: all .4s;
}

.tabs {
  width: 12.25%;
  position: relative;
}

.tabs>a>div {
  padding-left: 10px;
}

.gray::before {
  content: "";
  position: absolute;
  top: 20%;
  bottom: 0;
  left: 0;
  width: 2px;
  background-color: var(--fit20-lighter-gray);
  transition: background-color 0.5s;
}

.green::before {
  content: "";
  position: absolute;
  top: 20%;
  bottom: 0;
  left: 0;
  width: 2px;
  background-color: var(--fit20-green);
  transition: background-color 0.5s;
}

.burger {
  width: 10%;
  margin-left: auto;
}

.burger-div {
  text-align: right;
  padding-right: 15px;
}

.burger img {
  width: 45px;
}

.dynamic-btn {
  margin-top: 10px;
  animation: appear-main .6s;
}

.close-btn {
  margin-right: 10px;
  animation: appear-main .6s;
}

@keyframes appear-main {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes menu-animation {
  from {
    width: 0;
  }

  to {
    width: 30%;
  }
}

.header .side-menu {
  width: 30%;
  position: fixed;
  top: 10px;
  right: 10px;
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  background-color: white;
  z-index: 10;
  padding: 10px 5px 0px 5px;
  animation: menu-animation .6s;
}

.menu-header .close {
  position: absolute;
  right: 15px;
  top: 15px;
}

.trainer-name {
  padding-left: 10px;
  color: var(--fit20-green);
}

.menu-items {
  margin-top: 15px;
  margin-left: 50px;
}

.menu-items div {
  padding: 5px 0;
  margin-bottom: 8px;
  color: var(--fit20-gray);
}

.sensor-icon {
  text-align: right;
}

.add-member-body form {
  width: 100%;
  margin: auto;
  padding-left: 10px;
  padding-bottom: 30px;

}

.edit-user-body {
  width: 80%;
}

.add-member-studio {
  color: var(--fit20-gray);
  padding-left: 10px;
  margin-top: 20px;
}

.edit-user-sec {
  justify-content: space-around;
  padding-bottom: 20px;
}

.user-img-div {
  margin-top: 15px;
  position: relative;
}

.user-img-div img {
  border-radius: 5px;
}

.user-img-ico {
  position: absolute;
  top: 70px;
  right: 0;
}

.menu-header>div>img {
  border-radius: 5px;
}

.malfunction-text {
  width: 100%;
}

.malfunction-text textarea {
  width: 100% !important;
  height: 200px;
}

.description-container {
  margin-top: 20px;
}
</style>
